import { defineApi } from '@/utils/fetch';

import type {
    IGetDramaMallFeedsParams,
    IGetDramaMallHomeParams,
    TGetDramaMallFeedsResponse,
    TIGetDramaMallHomeResponse,
} from './typings';

export const DramaMallApi = {
    /** 获取短剧 feed 列表 */
    getDramaMallFeeds: defineApi<IGetDramaMallFeedsParams, TGetDramaMallFeedsResponse>({
        url: '/drama_mall/feeds',
        method: 'GET',
    }),

    /** 获取短剧首页模块 */
    getDramaMallHome: defineApi<IGetDramaMallHomeParams, TIGetDramaMallHomeResponse>({
        url: '/drama_mall/home',
        method: 'GET',
        waitForSession: true,
    }),
};

export * from './typings';
